<button *ngIf="!href; else linkTemplate"
        [disabled]="disabled"
        (click)="clickIn.next()"
        [type]="type"
        mat-raised-button
        color="primary">
    {{ text }}
</button>

<ng-template #linkTemplate>
    <a [routerLink]="href"
       mat-raised-button
       color="primary">
        {{ text }}
    </a>
</ng-template>

